import { ErrorComponent, type ErrorComponentProps } from '@tanstack/react-router';
import { isSessionRefusal } from '@wundo/client/session.ts';
import { Button, EmptyState } from '@wundo/ui';

/*
 * The guards have already re-run by the time a refusal lands here and still let
 * this session in: a "Login as" customer standing on a staff page. That is a
 * state to name, not a crash. Anything else keeps the router's own error view.
 */
export function RouteError(props: ErrorComponentProps) {
  if (!isSessionRefusal(props.error)) {
    return <ErrorComponent {...props} />;
  }

  return (
    <EmptyState
      title='This session has no access to this page'
      description='The session in this browser changed, or it is not allowed to see this.'
      action={
        <Button type='button' variant='accent' onClick={() => window.location.reload()}>
          Reload
        </Button>
      }
    />
  );
}
